<template>
  <div class="create-project" style="margin-top: 0" v-if="!hasProposals">
    <div class="tab">
      <h1>Propostas</h1>
    </div>
    <div class="section">
      <div class="card p-4">
        <img src="/assets/img/proposal.svg" alt="" />
        <h2 class="light mt-2">Nenhuma proposta recebida</h2>
      </div>
    </div>
  </div>
  <div v-else>
    <div
      class="alert alert-warning mt-3"
      v-if="hasContacts && contactsLeft > 0 && project.status === 2"
    >
      Você já solicitou o contato de
      {{ formatPlural(project.released_contacts, "assistente", "assistentes") }}
      neste projeto. Você ainda pode conversar com mais
      {{ formatPlural(contactsLeft, "assistente", "assistentes") }}.
    </div>
    <div
      class="alert alert-warning mt-3"
      v-else-if="hasContacts && contactsLeft < 1 && project.status === 2"
    >
      Você atingiu o limite de
      {{ formatPlural(project.max_contacts, "contato", "contatos") }} para este projeto.
    </div>
    <div
      class="alert alert-warning mt-3"
      v-else-if="contactsLeft > 0 && project.status === 2"
    >
      Você pode conversar com até
      {{ formatPlural(contactsLeft, "assistente", "assistentes") }}.
    </div>
    <h1 v-if="!hideTitle">Propostas</h1>

    <div
      class="contact"
      v-for="proposal in proposals"
      :key="proposal.project_id + '_' + proposal.assistant_id"
      :id="proposal.assistant_id"
    >
      <Proposal :project="project" :proposal="proposal" />
    </div>

    <div class="page_number">
      <button
        id="fetchMoreProposals"
        class="btn see_more btn-small"
        @click="fetchMore()"
        v-if="hasMore"
        :class="{ disabled: loadingMore }"
      >
        {{ loadingMore ? "Carregando..." : "Mostrar mais" }}
      </button>
    </div>
  </div>
</template>

<script>
import { toHandlers } from "vue";
import ClientManager from "../../../js/services/client.js";
import Proposal from "./Proposal.vue";

export default {
  props: ["project", "proposalCount", "hideTitle"],
  data() {
    return {
      loading: false,
      error: false,
      loadingMore: false,
      hasMore: this.project.proposals.hasMore,
      proposals: [
        ...this.project.proposals.releasedProposals,
        ...this.project.proposals.virtapClubProposals,
        ...this.project.proposals.otherProposals,
      ],
      excludedIds: [
        ...this.project.proposals.releasedProposals.map((p) => p.position),
        ...this.project.proposals.virtapClubProposals.map((p) => p.position),
      ],
      lastOtherProposal:
        this.project.proposals.otherProposals.length > 0
          ? this.project.proposals.otherProposals[
              this.project.proposals.otherProposals.length - 1
            ]
          : null,
    };
  },
  components: { Proposal },
  computed: {
    activeUser() {
      return this.$store.state.activeUser;
    },
    hasProposals() {
      return this.proposals.length > 0;
    },
    hasContacts() {
      if (this.project && this.project.released_contacts > 0) {
        return true;
      }
      return false;
    },
    contactsLeft() {
      if (this.project) {
        return this.project.max_contacts - this.project.released_contacts;
      }
      return 0;
    },
  },
  methods: {
    
    async fetchMore() {
      let ctx = this;
      ctx.loadingMore = true;
      try {
        let response = await ClientManager.getProposals(
          this.project.id,
          this.excludedIds,
          this.lastOtherProposal
        );
        if (response.otherProposals.length > 0) {
          this.proposals = [...this.proposals, ...response.otherProposals];
          this.lastOtherProposal =
            response.otherProposals[response.otherProposals.length - 1];
          console.log(this.lastOtherProposal);
        }
        this.hasMore = response.hasMore;

        if (response.otherProposals.length > 0) {
          ctx.applyTruncation(() => {
            ctx.initTooltips();

            let lastCard = $(".proposal-page")
              .find("#" + response.otherProposals[0].assistant_id)
              .get(0);
            let scrollDiv = lastCard.offsetTop - 86;
            window.scrollTo({ top: scrollDiv, behavior: "smooth" });
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        ctx.loadingMore = false;
      }
    },
  },
};
</script>
